import React from "react";
import { Link } from "gatsby";

const Button = ({
  children,
  className,
  target,
  onClick,
  _blank,
  activeClassName,
}) => {
  if (target) {
    return (
      <Link
        className={`line-crop font-display inline-block cursor-pointer rounded px-6 uppercase leading-[3em] tracking-[0.08em] text-white transition duration-300 ${
          className ? className : ""
        }`}
        activeClassName={activeClassName ? activeClassName : ""}
        to={target}
        onClick={onClick}
        target={_blank ? "_blank" : ""}
      >
        {children}
      </Link>
    );
  } else {
    return (
      <div
        className={`line-crop font-display inline-block cursor-pointer rounded px-6 uppercase leading-[3em] tracking-[0.08em] text-white transition duration-300 ${
          className ? className : ""
        }`}
        activeClassName={activeClassName ? activeClassName : ""}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
};

export default Button;
